// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"37677d14","237":"37677d14","355":"37677d14","382":"37677d14","613":"37677d14","638":"37677d14","678":"37677d14","696":"37677d14","761":"37677d14","887":"37677d14"}[chunkId] + ".chunk.css";
};